"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useValidateSchema = void 0;
var next_intl_1 = require("next-intl");
var react_1 = require("react");
var yup = __importStar(require("yup"));
var useValidateSchema = function () {
    var t = (0, next_intl_1.useTranslations)('errors');
    return (0, react_1.useMemo)(function () {
        return yup.object({
        // email: yup
        //   .string()
        //   .email(t('invalidEmail'))
        //   .required(t('emailIsRequired')),
        // firstName: yup.string().required(t('firstNameIsRequired')),
        // lastName: yup.string().required(t('lastNameIsRequired')),
        // dateOfBirth: yup.string().required(t('dateOfBirthIsRequired')),
        // phone: yup
        //   .string()
        //   .required(t('phoneIsRequired'))
        //   .min(8, t('phoneIsInvalid')),
        // gender: yup.object().required(t('genderIsRequired')),
        });
    }, [t]);
};
exports.useValidateSchema = useValidateSchema;
exports.default = exports.useValidateSchema;
